import { mapActions, mapState } from 'vuex'

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const countriesComputed = { ...mapState('countries', {countries: (state) => state.countries })}
export const countriesMethods = mapActions('countries', ['fetchCountries'])

export const newComputed = { ...mapState('news', {news: (state) => state.news })}
export const newMethods = mapActions('news', ['fetchNews'])

export const districtComputed = { ...mapState('districts', {districts: (state) => state.districts })}
export const districtMethods = mapActions('districts', ['fetchDistricts'])

export const packageComputed = { ...mapState('packages', {packages: (state) => state.packages })}
export const packageMethods = mapActions('packages', ['fetchPackages'])


